import { useCallback, useState } from 'react';
import { retrieveEventParticipants } from 'src/pages/admin/services/whitelistService';

export interface EventParticipantRewards {
  earlyBirdUsdc: string;
  referralUsdc: string;
  leaderboardUsdc: string;
  totalUsdc: string;
}

export interface EventParticipant {
  userId: string;
  walletAddress: string;
  proxyWalletAddress: string;
  email: string;
  status: string;
  unlockSource: string | null;
  manualNotes: string | null;
  redemptionCode: string | null;
  cumulativeVolumeUsdc: string;
  validReferralCount: number;
  ticketsTotal: number;
  rewards: EventParticipantRewards;
  registeredAt: number;
}

const useEventParticipants = () => {
  const [records, setRecords] = useState<EventParticipant[]>([]);
  const [total, setTotal] = useState<number>(0);

  const retrieve = useCallback(
    async (
      page: number,
      pageSize: number,
      search?: string,
      statuses?: string[],
      orderField?: string,
      orderDirection?: string
    ) => {
      try {
        const response = await retrieveEventParticipants(
          page,
          pageSize,
          search,
          statuses,
          orderField,
          orderDirection
        );
        setRecords(response.data.items ?? response.data.data ?? []);
        setTotal(response.data.total ?? 0);
      } catch (error) {
        console.log('error: ', error);
      }
    },
    []
  );

  return { retrieve, records, total };
};

export default useEventParticipants;
